import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
/** returns the first promo in publicSessions.promos if any */ export function useCurrentPromo(promoType) {
    const { promos  } = useContext(SessionContext);
    const currentPromos = promos === null || promos === void 0 ? void 0 : promos.filter((i)=>i.type === promoType);
    return currentPromos && (currentPromos.length > 0 ? currentPromos === null || currentPromos === void 0 ? void 0 : currentPromos[0] : undefined);
}
